/*
*
* Get JS dep with Browserify
*
 */

global.jQuery = window.$ = require('jquery');
var slick = require('slick-carousel');
var imagesLoaded = require('imagesloaded');
var odometer = require('odometer');
var velocity = require("velocity-animate");
require('jquery.dotdotdot');
imagesLoaded.makeJQueryPlugin( $ );

/*
*
* Declare the app as an object
*
*/

var app = window.app = {


    init: function() {
      this.handleToggleMobileBtn();
      this.breakMenu();
      $(window).on('resize', function () {
        app.breakMenu();
      });
      this.handleLangSwitcher();
      this.fixHeader();
      $(window).on('scroll', function() {
        app.fixHeader();
      });
    },
    isMobile: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
          .test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          .test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    isMobileOrTablet: function () {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i
          .test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          .test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);

      return check;
    },
    getIEVersion : function () {

        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var check = '';
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            check = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
        }

        return check;
    },
    isIE : function () {
      return !!this.getIEVersion();
    },
    addIEVersionToBody : function (){
      if(this.isIE()){
        $('html').addClass('ie-'+this.getIEVersion());
      }

    },
    fixHeader: function () {
      var scrolled = $(document).scrollTop();
      var body = $('body');
      var treshold = 40;
      console.log(scrolled, treshold);
      if(!body.hasClass('header-fixed') && scrolled > treshold){        
        
        body.addClass('header-fixed');
      }
      else if (body.hasClass('header-fixed') && scrolled <= treshold) {
        body.removeClass('header-fixed');
      }
      
    },
    breakMenu: function () {
      if($(window).width() > 1000 && $(window).width() < 1200){
        if($('.menu-breaker').length === 0){
          $('#main-nav .restart').before('<li class="menu-breaker"></li>');
        }

      }
      else {
        if($('.menu-breaker').length){
          $('.menu-breaker').remove();
        }
      }

    },
    onResize: function () {

    },
    handleToggleMobileBtn: function () {
      $('#toggle-mobile').on('click', function () {
        $('body').toggleClass('menu-opened');
      });
    },
    handleLangSwitcher: function () {
      $('.current-lang').on('click', function (e) {
        e.preventDefault();
        $(this).next().toggleClass('visible');
      });
    },
    initMap : function () {

      if($('#inner-map-container').length){
        var position = {lat: 48.8304094, lng: 2.7245278};
        if($('html').attr('lang').indexOf('PT') > -1){
          position = { lat: 39.698383, lng: -8.919827 };
        }
        var mapInner = new google.maps.Map(document.getElementById('inner-map-container'), {
            center: position,
            scrollwheel: false,
            zoom: 14
          });
          var markerInner = new google.maps.Marker({
              position: position,
              map: mapInner
            });
      }


    },
    home: {

      init: function () {
        this.initCarousel();
      },
      initCarousel : function () {
        $('#home-slider').slick({
          dots: true,
          arrows: true,
          infinite: true,
          speed: 1200,
          fade: true,
          autoplay: true,
          pauseOnHover: false,
          autoplaySpeed: 5000,
          appendDots: $('.slider-arrows-dots'),
          appendArrows: $('.slider-arrows-dots')
        });
      }


    },
    standard: {
      init: function () {
        this.initCarousel();
      },
      initCarousel: function () {
        if( $('.slider-container').length ){
          $('.slider-container').imagesLoaded(function () {
            $('.slider-container').slick({
              dots: true,
              arrows: true,
              infinite: true,
              speed: 1200,
              fade: true
            });
            $('.slick-arrow, .slick-dots').css('top', $('.slick-active img').height()+'px');
          });

        }
      }
    },
    singleOffre: {
      init: function () {
        this.initCarousel();
        this.resizeCols();
      },
      resizeCols: function () {
        var maxHeight = Math.max($('.specs-container').height(), $('.pros-container').height());
        $('.specs-container, .pros-container').height(maxHeight);
      },
      initCarousel: function () {
        if( $('.slider-container').length ){
          $('.slider-container').imagesLoaded(function () {
            $('.slider-container').slick({
              dots: true,
              arrows: true,
              infinite: true,
              speed: 1200,
              fade: true
            });
            $('.slick-arrow, .slick-dots').css('top', $('.slick-active img').height()+'px');
          });

        }
      }
    },
    contact: {
      init: function () {
        this.selectWrapper();
        this.selectHandler();
      },
      selectWrapper: function () {
        $('.wpcf7-select').each(function () {
          $(this).wrap('<div class="select-wrapper" />');
          $(this).parent().append('<span class="select-value"></span>')
        });
      },
      selectHandler: function () {
        $('.wpcf7-select').each(function () {
          $(this).next().html($(this).find(':selected').text());
        });
        $('.wpcf7-select').on('change', function () {
          $(this).next().html($(this).find(':selected').text());
        });
      }
    },
    international: {
      init: function () {
        this.togglePins();
        this.toggleContent();
        this.dddInit();
        $(window).on('resize', function() {
          app.international.dddInit();
        });
        
      },
      dddInit: function () {
        if($(window).width() < 1200){
          $('.page-content').dotdotdot();        
        }
        else {
          if($('.ddd-truncated').length){
            $('.ddd-truncated').dotdotdot().destroy();
          }
          
        }
      },
      toggleContent: function () {
        $('#ri-read-more').on('click', function (e) {
          var labelOpened = $(this).attr('data-label-opened');
          var labelClosed = $(this).attr('data-label-closed');
          e.preventDefault();
          $(this).prev().toggleClass('opened');
          if($(this).prev().hasClass('opened')){
            $(this).text(labelOpened);
          }
          else {
            $(this).text(labelClosed);
            
          }
          $('.page-content').dotdotdot();
        });
      },
      togglePins: function () {
        $('.ri-close').on('click', function () {
          $(this).parents('.rabourdin-hq').removeClass('opened');
        });
        $('.ri-pin').on('click', function () {
          var that = $(this);
          
          if(!that.parent().hasClass('opened')){
            $('.rabourdin-hq').removeClass('opened');
            that.parent().addClass('opened');
          }
          else {
            $('.rabourdin-hq').removeClass('opened');
          }
          
        });
      }
    },
    estimate: {
      data: '',
      orderedData : [],
      stepNb: 1,
      query: '',
      init: function () {

        // Redirect to HP on mobile
        if($(window).width() < 900){
          window.location.href = SITE_URL;
        }
        var stepNb = this.stepNb = parseInt($('.page-estimate-container').attr('data-step'));

        if(stepNb === 1){

          if(window.localStorage.getItem('estimate_form_data') !== null){
            this.orderedData = JSON.parse(window.localStorage.getItem('estimate_form_data'));
            this.addOrderedResultsToDOM();
          }

          this.storeProductData();
          this.handleQuerySubmit();
          this.handleStep1SendBtn();
          if(window.localStorage.getItem('estimate_form_last_query') !== null){
            this.query = window.localStorage.getItem('estimate_form_last_query');
            $('#estimate-query').val(this.query);
            $('#estimate-query-form').submit();
          }

        }
        else if ( stepNb == 2){
          this.handleStep2Data();
          this.addOrderedResultsToTextarea();
        }
        this.handleIncrementBtn();
        this.handleAddBtn();
        this.handleRemoveBtn();

      },
      storeProductData : function () {
        this.data = JSON.parse($('#estimate-data').attr('data-product-json'));
      },
      handleStep1SendBtn : function () {
        var self = this;
        $('#estimate-send').on('click', function (e) {
          // @TODO : gérer erreurs form
          var href = $(this).attr('data-step2-url');
          window.localStorage.setItem('estimate_form_data', JSON.stringify(self.orderedData));
          window.location.href = href;
        });
      },
      handleStep2Data : function () {
        var self = this;
        this.orderedData = JSON.parse(window.localStorage.getItem('estimate_form_data'));
        this.addOrderedResultsToDOM();
      },
      handleRemoveBtn : function () {
        var self = this;
        $(document).on('click', '.results-remove', function () {
          var $this = $(this),
              currentRef = $this.attr('data-full-ref'),
              refs = self.orderedData.map(function (item) {
                return item.full_ref;
              });
              if(refs.indexOf(currentRef) > -1) {
                self.orderedData.splice(refs.indexOf(currentRef), 1);
                self.addOrderedResultsToDOM();
              }

        });
      },
      handleAddBtn : function () {
        var self = this;
        $(document).on('click', '.results-add', function () {
          var $this = $(this),
              qty = parseInt($this.parent().find('input').val()),
              dataToAdd = JSON.parse($this.parent().find('.result-data-to-add').html());
          if(qty){
            var refs = self.orderedData.map(function (item) {
              return item.full_ref;
            }),
                currentRefIndex = refs.indexOf(dataToAdd.full_ref);

            if(currentRefIndex > -1) {
              self.orderedData[currentRefIndex].qty += qty;
            }
            else {
              dataToAdd.qty = qty;
              self.orderedData.push(dataToAdd);

            }
            self.addOrderedResultsToDOM();
          }

        });
      },
      handleIncrementBtn : function () {
        $(document).on('click', '.btn-inc', function (e){

          var $this = $(this),
              inputNumber = $this.parent().find('input'),
              inputOldValue = parseInt(inputNumber.val()),
              inputNewValue = 0;

          if($this.hasClass('btn-sup')){
            inputNewValue = inputOldValue+1;
          }
          else {
            if(inputOldValue > 0){
              inputNewValue = inputOldValue-1;
            }
            else {
              inputNewValue = 0;
            }

          }
          inputNumber.val(inputNewValue);
        });
      },
      handleQuerySubmit : function () {
        var self = this;
        $('#estimate-query-form').on('submit', function (e) {
          e.preventDefault();
          var query = $('#estimate-query').val().length ? $('#estimate-query').val() : self.query;
          self.query = query;
          window.localStorage.setItem('estimate_form_last_query', self.query);

          if(query.length > 2){
            var results = self.data.filter(function (product) {
              return product.full_ref.indexOf(query) > -1;
            });
            if(results.length){
              self.addResultsToDOM(results);
            }
            else {
              self.emptyResultsFromDOM();
            }

          }
          else {

          }
        });
      },
      handleQueryChange : function () {
        var self = this;
        $('#estimate-query').on('keyup', function () {
          var query = $(this).val();

          if(query.length > 2){
            var results = self.data.filter(function (product) {
              return product.full_ref.indexOf(query) > -1;
            });
            self.addResultsToDOM(results);
          }
          else {
            self.emptyResultsFromDOM();
          }

        });
      },
      addOrderedResultsToDOM : function () {
        var html = '';

        var el = this.stepNb === 1 ? $('#estimate-order') : $('#estimate-results');
        if(this.orderedData.length > 0){

          for (var i = 0; i < this.orderedData.length; i++) {
            var current_result = this.orderedData[i];
            html += '<tr class="estimate-result"><td class="result--full-ref">'+current_result.full_ref+'</td><td class="result--title"><span class="result--title-fr">'+current_result.title+'</span> - <span class="result--title-en">'+current_result.title_en+'</span></td><td class="result--actions"><button class="btn-inc btn-sub">-</button><input type="number" value="'+current_result.qty+'" placeholder="0"/><button class="btn-inc btn-sup">+</button><button class="results-remove" data-full-ref="'+current_result.full_ref+'"></button></td></tr>';
          }
          el.addClass('visible').find('tbody').html(html);
        }
        else {
          el.removeClass('visible').find('tbody').html(html);
        }
        this.addOrderedResultsToTextarea();
      },
      addOrderedResultsToTextarea : function () {
        var textAreaHtml = '';
        if(this.stepNb === 2){
          for (var i = 0; i < this.orderedData.length; i++) {
            var current_result = this.orderedData[i];
            textAreaHtml += '- Référence : '+current_result.full_ref+' | Nom :'+current_result.title+' | Quantité : '+current_result.qty +'&#13;&#10;';
          }
          $('#form-textarea-ordered-data').html(textAreaHtml);
        }
      },
      emptyResultsFromDOM : function () {
        $('#estimate-results').removeClass('visible').find('tbody').html('');
        $('#estimate-no-results').addClass('visible');
      },
      addResultsToDOM : function (results) {
        var addLabel = $('#estimate-results').attr('data-add-label');
        var html = '';
        for (var i = 0; i < results.length; i++) {
          var current_result = results[i];
          html += '<tr class="estimate-result"><td class="result--full-ref">'+current_result.full_ref+'</td><td class="result--title"><span class="result--title-fr">'+current_result.title+'</span> - <span class="result--title-en">'+current_result.title_en+'</span></td><td class="result--actions"><button class="btn-inc btn-sub">-</button><input type="number" value="0" placeholder="0"/><button class="btn-inc btn-sup">+</button><button class="btn btn-green results-add">'+addLabel+'</button><span class="result-data-to-add">'+JSON.stringify(results[i])+'</span></td></tr>';
        }
        $('#estimate-no-results').removeClass('visible');
        $('#estimate-results').addClass('visible').find('tbody').html(html);
      }
    }
};


/*
*
* Wait for DOM ready and init() the app
*
*/

$(document).ready(function () {
	// DOM is ready
  app.init();
  if($('.page-template-template-home').length ){
    app.home.init();
  }
  if($('.page-template-template-estimate').length || $('.page-template-template-estimate-step-2').length){
    app.estimate.init();
  }
  if($('.page-template-template-standard').length){
    app.standard.init();
  }
  if($('.page-template-template-offre-standard-single').length){
    app.singleOffre.init();
  }
  if($('.page-template-template-contact').length){
    app.contact.init();
  }
  if($('.page-template-template-ri').length){
    app.international.init();
  }
});
